/* OB Cycling · V6 behaviour (runs once, window.__cy6): swipe rails, quick add + toast, deal countdown, reels play in
   view, kit flip on tap, hero pins on tap, sticky bar + cart count. Kits / quiz / weather use ob-cycling-plus.js. */
(function () {
  if (window.__cy6) return;
  window.__cy6 = true;
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  if (root.slice(-1) !== '/') root += '/';
  var design = !!(window.Shopify && Shopify.designMode);
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var cur = window.obcyCur || 'AED';
    if (cur === 'AED') return '<bdi dir="ltr"><span class="po-aed" aria-hidden="true"></span><span class="obcy-vh">AED </span>' + s + '</bdi>';
    return '<bdi dir="ltr">' + cur + ' ' + s + '</bdi>';
  }

  /* ---------- cart count + toast ---------- */
  function refreshCart() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cy6-count]').forEach(function (el) { el.textContent = c.item_count; });
      document.querySelectorAll('[data-cy6-total]').forEach(function (el) { el.innerHTML = money(c.total_price); });
      document.querySelectorAll('[data-cy6-cart]').forEach(function (el) { el.hidden = c.item_count === 0; });
    }).catch(function () {});
  }
  var toastEl;
  function toast(msg, link, label) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cy6 cy6-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span></span>' + (link ? '<a href="' + link + '"></a>' : '');
    toastEl.firstChild.textContent = msg;
    if (link) toastEl.lastChild.textContent = label;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl.t);
    toastEl.t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cy6-add]');
    if (!b) return;
    e.preventDefault();
    var v = b.getAttribute('data-v');
    if (!v) { location.href = b.getAttribute('data-url'); return; }
    b.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +v, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        b.classList.add('is-ok'); b.disabled = false;
        setTimeout(function () { b.classList.remove('is-ok'); }, 1600);
        var w = document.querySelector('[data-cy6-strings]');
        toast((w && w.getAttribute('data-added')) || 'Added to cart', root + 'cart', (w && w.getAttribute('data-view')) || 'View cart');
        refreshCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { b.disabled = false; location.href = b.getAttribute('data-url') || (root + 'cart'); });
  });

  /* ---------- swipe rails ---------- */
  function initRail(r) {
    if (r.__cy6) return; r.__cy6 = true;
    var s = r.querySelector('[data-cy6-swipe]'); if (!s) return;
    var prev = r.querySelector('[data-cy6-prev]'), next = r.querySelector('[data-cy6-next]'), bar = r.querySelector('[data-cy6-bar] i');
    function upd() {
      var max = s.scrollWidth - s.clientWidth, x = Math.abs(s.scrollLeft);
      var w = s.scrollWidth ? s.clientWidth / s.scrollWidth : 1;
      if (bar) { bar.style.width = Math.min(100, w * 100) + '%'; bar.style.insetInlineStart = (max > 0 ? x / max * (1 - Math.min(1, w)) * 100 : 0) + '%'; }
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      var wrap = r.querySelector('[data-cy6-bar]'); if (wrap) wrap.hidden = max <= 2;
    }
    function go(d) {
      var c = s.firstElementChild; if (!c) return;
      var gap = parseFloat(getComputedStyle(s).columnGap) || 16;
      var rtl = getComputedStyle(s).direction === 'rtl';
      s.scrollBy({ left: d * (c.getBoundingClientRect().width + gap) * 2 * (rtl ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    s.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- deal countdown ---------- */
  function initCd(c) {
    if (c.__cy6) return; c.__cy6 = true;
    var end = Date.parse(c.getAttribute('data-end'));
    if (isNaN(end)) return;
    var sec = c.closest('.shopify-section') || c;
    function pad(n) { return ('0' + n).slice(-2); }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { if (!design) sec.hidden = true; return; }
      var set = function (k, v) { var el = c.querySelector('[data-' + k + ']'); if (el) el.textContent = v; };
      set('d', pad(Math.floor(s / 86400))); set('h', pad(Math.floor(s % 86400 / 3600))); set('m', pad(Math.floor(s % 3600 / 60))); set('s', pad(s % 60));
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- reels ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var r = e.target, v = r.querySelector('video');
      if (e.isIntersecting && !reduce) { r.classList.add('is-play'); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      else { r.classList.remove('is-play'); if (v) v.pause(); }
    });
  }, { threshold: .6 }) : null;
  function initReel(r) {
    if (r.__cy6) return; r.__cy6 = true;
    if (io) io.observe(r);
    var b = r.querySelector('.cy6-reel__play'), v = r.querySelector('video');
    if (b) b.addEventListener('click', function () {
      if (v) { if (v.paused) { v.play(); r.classList.add('is-play'); } else { v.pause(); r.classList.remove('is-play'); } }
      else r.classList.toggle('is-play');
    });
  }

  /* ---------- kits flip (tap), hero pins (tap) ---------- */
  document.addEventListener('click', function (e) {
    var fa = e.target.closest && e.target.closest('.cy6-kit__fa');
    if (fa) { fa.closest('.cy6-kit').classList.add('is-flip'); return; }
    var bk = e.target.closest && e.target.closest('[data-cy6-unflip]');
    if (bk) { bk.closest('.cy6-kit').classList.remove('is-flip'); return; }
    var pin = e.target.closest && e.target.closest('.cy6-pin');
    if (pin && !pin.classList.contains('is-on') && window.matchMedia('(hover: none)').matches) { e.preventDefault(); pin.classList.add('is-on'); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var fa = e.target.closest && e.target.closest('.cy6-kit__fa');
    if (fa) { e.preventDefault(); fa.closest('.cy6-kit').classList.add('is-flip'); var b = fa.closest('.cy6-kit').querySelector('[data-obp-add]'); if (b) setTimeout(function () { b.focus(); }, 400); }
  });

  /* ---------- sticky bar ---------- */
  function initStick(s) {
    if (s.__cy6) return; s.__cy6 = true;
    var after = +(s.getAttribute('data-after') || 600);
    var ft = document.querySelector('footer, .footer, #shopify-section-footer, [id*="footer-group"]');
    function on() {
      var nearEnd = ft && ft.getBoundingClientRect().top < window.innerHeight;
      s.classList.toggle('is-on', window.scrollY > after && !nearEnd);
    }
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-cy6-rail]').forEach(initRail);
    scope.querySelectorAll('[data-cy6-cd]').forEach(initCd);
    scope.querySelectorAll('.cy6-reel').forEach(initReel);
    scope.querySelectorAll('[data-cy6-stick]').forEach(initStick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
